<template>
  <div class="projectCard" ref="card" id="card">
    <div id="imageContainer" v-if="project.images" :class="[!(windowWidth > 900 && windowWidth < 1280) ? 'column' : 'full', windowWidth < 650 ? 'small' : 'big']">
      <img @click="openGallery" :src="'/companies/' + project.images[0]" />
    </div>
    <section class="projectInformation" :class="[!(windowWidth > 900 && windowWidth < 1280) ? 'column' : 'full', !project.images ? 'fullWidth' : '']">
      <section class="appName">
        <h1 v-if="project.name">{{project.name}}</h1>
        <p>{{project.description}}</p>
      </section>
      <section class="myRole">
        <h1>{{$t("work.role")}}</h1>
        <p>{{project.myRole}}</p>
      </section>
      <section class="technologies">
        <h1>{{$t("work.techsUsed")}}</h1>
        <p>{{getTechnologiesUsed()}}</p>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  props: [
    'project'
  ],
  data() {
    return {
      width: 0
    }
  },
  computed: {
    windowWidth() {
      return this.width
    }
  },
  methods: {
    getWindowWidth() {
        this.width = document.documentElement.clientWidth;
      },
    getTechnologiesUsed() {
      return this.project.technologies.join(", ").toString()
    },
    openGallery() {
      this.$emit('gallery', this.project.images)
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);

      //Init
      this.getWindowWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }
};
</script>


<style scoped>
img:hover {
  cursor: pointer;
}
#imageContainer img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
#imageContainer {
  align-content: flex-start;
}
#imageContainer.full {
  display: inline-block;
  width: 50%;
  height: 450px;
  margin-right: 1rem;
  vertical-align: top;
}
#imageContainer.column {
  width: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
}

#imageContainer.column.big {
  height: 550px;
}
#imageContainer.column.small {
  height: 315px;
}
.projectInformation.full {
  display: inline-block;
  width: 40%;
}
.projectInformation.column {
  display: block;
}
.projectInformation.fullWidth {
  width: 100%;
}
.projectCard >>> p {
  margin-bottom: 1rem;
}
button {
  border: none;
  padding: 0;
}
</style>


